<template>
  <video-player ref="videoPlayer" :options="playerOptions" :playsinline="true">
  </video-player>
</template>

<script>
export default {
  props: {
    videoSrc: String,
    contentEnabled: Boolean,
  },
  data() {
    return {
      // videojs options
      playerOptions: {
        //height: "360",
        autoplay: false,
        muted: false,
        aspectRatio: "16:9",
        language: "en",
      },
    };
  },
  mounted() {
    this.player.src({ type: "video/mp4", src: this.videoSrc });
    this.player.muted(false);
    if (this.contentEnabled) {
      this.player.play();
      this.$root.comms.send("singtel-setaudio", {
        title: "music",
        state: "pause",
      });
    }
  },
  beforeDestroy() {},
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
    contentEnabled: function (newVal) {
      if (newVal == true) {
        this.player.src({ type: "video/mp4", src: this.videoSrc });
        this.player.play();
        this.$root.comms.send("singtel-setaudio", {
          title: "music",
          state: "pause",
        });
      } else {
        this.player.reset();
        this.$root.comms.send("singtel-setaudio", {
          title: "music",
          state: "play",
        });
      }
    },
  },
  methods: {
    setVideoState(state) {
      console.log("setVideoState");
      console.log(state);
    },

    beforeChangeLocation() {
      this.$root.comms.send("singtel-setaudio", {
        title: "music",
        state: "play",
      });
      this.player.reset();
    },
  },
};
</script>
